// Environment-gated feature flags.
//
// Production is play.ourvisualbrain.com. Everything else (devplay, testplay,
// localhost) is treated as non-production so unfinished features can be
// exercised before they reach customers.

export const isProduction = () => window.location.hostname.startsWith('play.')

// Tenants that get Testing Center on PRODUCTION before the general rollout.
// Add an app_tenant_id here to switch a clinic on; everything off production
// (devplay, testplay, localhost) ignores this list and has the feature anyway.
//
// This is a visibility gate, not a security boundary. A determined user in
// another clinic could still reach the feature; the worst case is that they
// take a test, which is acceptable while we pilot.
export const TESTING_CENTER_TENANTS = [
  '3713764392827880597', // SPARCC (OcuReady Rapid Screen, 2026-11-03)
  '2830948792050648893' // 5.4 Test Clinic_1 (Jen's test clinic, to try the Rapid Screen as SPARCC will)
]

// Reads the current tenant at call time. The store is imported lazily because
// featureFlags.js is imported by main.js and the router before the store
// exists, and a top-level import would deadlock that cycle.
const currentAppTenantId = () => {
  try {
    const store = require('@/store').default
    return store.state.user.userInfo.appTenantId || null
  } catch (e) {
    return null
  }
}

// The Testing Center staff screen (/admin/testing-center): super admins, and
// clinicians whose login has has_testing_center_access, for their own clinic.
// The API enforces the same rule (requireTestingAccess.ts).
export const canUseTestingCenterAdmin = () => {
  try {
    const userInfo = require('@/store').default.state.user.userInfo || {}
    const permissions = userInfo.permissions || []
    if (permissions.includes('p:super-admin')) return true
    return userInfo.hasTestingCenterAccess === true && permissions.includes('m:clinic')
  } catch (e) {
    return false
  }
}

export const featureFlags = {
  // Patient to-do task list. Live everywhere as of 2026-08-13.
  patientTasks: true,
  // Testing Center. The tc schema, the /api/testing routes and a handful of
  // assignment rows already exist on production, so this cannot rely on "no
  // data" to stay hidden. Gate the patient-facing entry points until the
  // feature is finished. The super-admin screens at /admin/testing-center are
  // intentionally NOT gated so they stay usable on production.
  //
  // A getter, not a value: the tenant is not known when this module loads, so
  // this has to be evaluated each time it is read.
  get testingCenter () {
    if (!isProduction()) return true
    return TESTING_CENTER_TENANTS.includes(currentAppTenantId())
  },
  // Run Testing Center activities inside an OVB frame instead of navigating
  // away to the game. Testing Center only — normal patient gameplay still
  // launches full screen through the untouched get-gameplay-session path.
  //
  // Tracks testingCenter deliberately: a pilot clinic that can see the feature
  // must get the framed player too, because the exit and return-to-dashboard
  // behaviour only works inside the frame.
  get testGameWrapper () {
    return this.testingCenter
  }
}
